import dynamic from "next/dynamic";
import MarkdownEmbeddedConfig from "./markdown-embedded-config";
import MarkdownEmbeddedAdvancedConfig from "./markdown-embedded-advanced-config";
const MarkdownEmbeddedComponent = dynamic(()=>import("./markdown-embedded-component"));
export default {
    MarkdownEmbeddedComponent,
    MarkdownEmbeddedConfig,
    MarkdownEmbeddedAdvancedConfig
};
